// extracted by mini-css-extract-plugin
export default {"content":"_3G6Dq_1M","logo":"_2p4SBWpe","heading":"_1_E93Fal","text":"_2_SUCRy9"};